import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useCountryCode } from 'querys/payment'
import { P } from 'common/typography'
import useDiff from 'hooks/use-diff'

const PriceStyled = styled.div`
  .limited-time {
    position: absolute;
    width: max-content;
    top: 16px;
    left: 16px;
    color: white;
    background: var(--secondary);
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    padding: 4px 8px;
  }
  .discount-price {
    display: inline-flex;
    align-items: center;
    span:first-of-type {
      color: var(--secondary);
      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
    }
    span:last-of-type {
      color: ${({ discountColor }) => discountColor};
      font-size: 14px;
      line-height: 24px;
      margin-left: 8px;
      text-decoration: line-through;
    }
  }
  ${({ small }) => small && `
    p {
      font-size: 16px!important;
      line-height: 24px;
    }
    .discount-price {
      span:first-of-type {
        font-size: 16px;
        line-height: 24px;
      }
      span:last-of-type {
        font-size: 12px;
        line-height: 16px;
      }
    }
  `}
  @media (min-width: 768px) {
    ${({ small }) => small && `
      p {
        font-size: 24px!important;
        line-height: 32px;
      }
      .discount-price {
        span:first-of-type {
          font-size: 24px;
          line-height: 32px;
        }
        span:last-of-type {
          font-size: 14px;
          line-height: 24px;
        }
      }
    `}
  }
`

function Price({
  price, discount, originalPrice, dataCy, children, limitedTime, small, discountColor, directDiscount,
}) {
  const { data: { countryCode } } = useCountryCode()
  const { diff: diffInTime } = useDiff(discount?.expires_at)
  const diff = diffInTime || (discount?.status === 'VALID' && !discount?.expires_at)
  const correctCountry = (price.currency_code === 'MXN' && countryCode === 'MX') || (price.currency_code === 'USD' && countryCode && countryCode !== 'MX')
  const couponvalid = discount && discount?.status && discount?.status === 'VALID'
  if (!correctCountry) return null
  // The coupon is valid but has expired
  if (couponvalid && !diff) {
    return (
      <PriceStyled discountColor={discountColor} small={small} data-cy={dataCy}>
        {limitedTime && <span className="limited-time">La oferta ha terminado :(</span>}
        {children && children}
        <P color="var(--secondary)" fontSize="24" lineHeight="32" fontWeight="700">${originalPrice?.amount} {originalPrice?.currency_code}</P>
      </PriceStyled>
    )
  }
  // The coupon is valid and its on time
  if (couponvalid && diff || directDiscount) {
    return (
      <PriceStyled discountColor={discountColor} small={small} data-cy={dataCy}>
        {limitedTime && <span className="limited-time">Promoción por tiempo limitado</span>}
        {children && children}
        <p className="discount-price">
          <span>${price.amount} {price.currency_code}</span>
          {directDiscount ? (
            <span className="discount">${directDiscount.amount} {directDiscount.currency_code}</span>
          ) : (
            <span className="discount">${originalPrice?.amount} {originalPrice?.currency_code}</span>
          )}
        </p>
      </PriceStyled>
    )
  }
  return (
    <PriceStyled discountColor={discountColor} small={small} data-cy={dataCy}>
      {children && children}
      <P color="var(--secondary)" fontSize="24" lineHeight="32" fontWeight="700">${price.amount} {price.currency_code}</P>
    </PriceStyled>
  )
}

Price.defaultProps = {
  limitedTime: true,
  small: false,
  discountColor: 'var(--lightText)',
}

Price.propTypes = {
  limitedTime: PropTypes.bool,
  small: PropTypes.bool,
  discountColor: PropTypes.string,
}

export default Price
